<div class="row">
    <div class="dialog-title">
        <ng-container *ngIf="clientInfo.dualAuthorization">
            <span class="text-fw-700">Payment approval | </span>Payment pending approval
        </ng-container>
        <ng-container *ngIf="!clientInfo.dualAuthorization">
            <span class="text-fw-700">Payment confirmation | </span>Payment complete
        </ng-container>
    </div>
</div>
<div class="row mb-4 text-center justify-content-center">
    <img class="complete-image" src="./assets/images/icon-png/check-dark.svg" alt="Payment Complete" />
</div>
<div class="row text-center justify-content-center mb-4">
    <div class="complete-text">
        <ng-container *ngIf="!clientInfo.dualAuthorization">
            Thank you for completing your payment.
        </ng-container>
        <ng-container *ngIf="clientInfo.dualAuthorization">
            Your payment has now been sent for approval
        </ng-container>
    </div>
</div>
<div class="row  justify-content-center mb-4">
    <div class="col-3 col-md-4 px-0" [class.mx-auto]="clientInfo.dualAuthorization">
        <button class="btn btn-block btn-lg btn-greengo-o" (click)="completeSendpayment()">Close</button>
    </div>
</div>
